import { cloneDeep } from 'lodash';

import { API_URL as BASE_API_URL } from '@funnels/constants';
import { SERVER_EMPLOYMENTS_V2_1, SERVER_EMPLOYMENTS_V2_2 } from '@funnels/mockdata';
import { StoreEmployment } from '@funnels/types';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';

function fetch(applicationId: string, applicantId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const data = [cloneDeep(SERVER_EMPLOYMENTS_V2_1), cloneDeep(SERVER_EMPLOYMENTS_V2_2)];
    return Promise.resolve({ data });
  }

  const url = `${BASE_API_URL}/v2/applications/${applicationId}/applicants/${applicantId}/employments`;
  return axios.get(url).then((res) => res.data);
}

function fetchAll(applicationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const data = [cloneDeep(SERVER_EMPLOYMENTS_V2_1), cloneDeep(SERVER_EMPLOYMENTS_V2_2)];
    return Promise.resolve({ data });
  }

  const url = `${BASE_API_URL}/v2/applications/${applicationId}/employments`;
  return axios.get(url).then((res) => res.data);
}

function update(applicationId: string, applicantId: string, employments: StoreEmployment[]): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const data = [cloneDeep(employments)];
    return Promise.resolve({ data });
  }

  const url = `${BASE_API_URL}/v2/applications/${applicationId}/applicants/${applicantId}/employments`;
  return axios.put(url, employments).then((res) => res.data);
}

export default { fetch, fetchAll, update };
